module.exports = __webpack_public_path__ + "img/four3Blue.1e9ddc94.png";